import { Link } from 'react-router-dom';
import React, {useState} from 'react';
import { callBackendAPI} from '../helpers/common';
import { useQuery } from "react-query";
import { STATUS_SUCCESS } from './../config/global_constants';
import { translate } from './../helpers/intl_helpers';
import flogoIcon from './../assets/images/f-logo.svg';
import facebookIcon from './../assets/images/facebook-icon.svg';
import instagramIcon from './../assets/images/instagram-icon.svg';
import twitterIcon from './../assets/images/twitter-icon.svg';
import linkedinIcon from './../assets/images/linkedin-icon.svg';
import youtubeIcon from './../assets/images/youtube-icon.svg';
import appstoreIcon from './../assets/images/app-store.svg';
import playStoreIcon from './../assets/images/google-play-store.svg';

export default function Footer({pageType="home", subPageType="", showToolbar=true, showProductToolbar=false, sortKey=null}){
	const [getFooterCategoryList, setFooterCategoryList] = useState({});
	const [topCities, setTopCities]   					 =	useState({});
		
	/**
	 * Get initial data
	 */
	const getOtherFooterInitialData = () => {
		/** Get Form data */
		callBackendAPI([
			{ model: 'home', method: 'getSettings', type: ["Site.copyright_text","Social.facebook","Social.twitter","Social.youtube","Social.linkedin","Social.instagram","App.android_link","App.apple_link"] },
			{ model: 'home', method: 'getHomePageDetails'}
		]).then(response => {
			if (response.success) {
				if (response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
					setFooterCategoryList(response.data[0].result);
				}
				if (response.data[1].status === STATUS_SUCCESS && response.data[1]) {
					setTopCities(response.data[1].top_cities);
				}

			}
		}).catch(err => console.log(err));
	}
	useQuery("getOtherFooterInitialData", getOtherFooterInitialData);

	return <>		
    <div className="footer">
        <div className="container">
			<figure className="f-logo"><img src={flogoIcon} alt="img" /></figure>
			<div className="footer-row">				
				<div className="information">
					<div className="footerlink">
						<a className="collapse-link collapsed" data-bs-toggle="collapse" href="#TheVoyia" role="button" aria-expanded="false" aria-controls="TheVoyia">{translate("footer.the_voyia")}</a>
						<div className="collapse" id="TheVoyia">
							<h4>{translate("footer.the_voyia")}</h4>
							<ul>
								<li><Link to="/about-us">{translate("footer.about_us")}</Link></li>
							</ul>
						</div>					
					</div>				
					<div className="footerlink">
						<a className="collapse-link collapsed" data-bs-toggle="collapse" href="#Information" role="button" aria-expanded="false" aria-controls="Information">{translate("footer.information")}</a>
						<div className="collapse" id="Information">
							<h4>{translate("footer.information")}</h4>
							<ul>
								<li><Link to="/terms-conditions">{translate("footer.tearms_and_conditions")}</Link></li>
								<li><Link to="/privacy-policy">{translate("footer.privacy_policy")}</Link></li>
								<li><Link to="/faq">{translate("footer.faq")}</Link></li>
							</ul>
						</div>
					</div>
				</div>
				{topCities && topCities.length > 0 ? (
					<div className="destination">				
						<div className="footerlink">
							<a className="collapse-link collapsed" data-bs-toggle="collapse" href="#Destinations" role="button" aria-expanded="false" aria-controls="Destinations">{translate("footer.destination")}</a>
							<div className="collapse" id="Destinations">
								<h4>{translate("footer.destination")}</h4>
								<ul>
									{topCities.map((cities,index)=>(
										<li key={'top-cities-'+index}><Link to={`/city/${cities.slug}`}>{cities.name ? cities.name : ''}</Link></li>
									))}
								</ul>	
							</div>
						</div>
					</div>
				):null}				
				<div className="follow-us">	
					<h4>{translate("user.download_the_app")}</h4>
					<div className="appstore-btn">	
						{getFooterCategoryList && getFooterCategoryList["App.apple_link"] ?
							<a href={getFooterCategoryList["App.apple_link"]} rel="noreferrer" target="_blank"><img src={appstoreIcon} alt="img" /></a>
						:""}
						{getFooterCategoryList && getFooterCategoryList["App.android_link"] ?
							<a href={getFooterCategoryList["App.android_link"]} rel="noreferrer" target="_blank"><img src={playStoreIcon} alt="img" /></a>
						:""}
						
					</div>				
				</div>
			</div>
			<div className="copyright">
				<p>{getFooterCategoryList["Site.copyright_text"]}</p>
				<ul className="social-icon">
					{getFooterCategoryList && getFooterCategoryList["Social.facebook"] ?
						<li><a href={getFooterCategoryList["Social.facebook"]} rel="noreferrer" target="_blank"><img src={facebookIcon} alt="img" /></a></li>
					:""}
					{getFooterCategoryList && getFooterCategoryList["Social.instagram"] ?
						<li><a href={getFooterCategoryList["Social.instagram"]} rel="noreferrer" target="_blank"><img src={instagramIcon} alt="img" /></a></li>
					:""}
					{getFooterCategoryList && getFooterCategoryList["Social.twitter"] ?
						<li><a href={getFooterCategoryList["Social.twitter"]} rel="noreferrer" target="_blank"><img src={twitterIcon} alt="img" /></a></li>
					:""}
					{getFooterCategoryList && getFooterCategoryList["Social.youtube"] ?
						<li><a href={getFooterCategoryList["Social.youtube"]} rel="noreferrer" target="_blank"><img src={youtubeIcon} alt="img" /></a></li>
					:""}
					{getFooterCategoryList && getFooterCategoryList["Social.linkedin"] ?
						<li><a href={getFooterCategoryList["Social.linkedin"]} rel="noreferrer" target="_blank"><img src={linkedinIcon} alt="img" /></a></li>
					:""}
					
				</ul>
			</div>
        </div>
    </div>
   		


	</>
}
